const ApproveCandidateIcon = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: any;
  onClick?: any;
}) => {
  return (
    <svg
      width="204"
      height="200"
      viewBox="0 0 204 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        d="M134.385 14.9757C134.385 14.9757 102.289 3.0197 71.1526 21.0197C40.0166 39.0197 24.6486 75.3317 11.4206 104.408C-1.80739 133.484 6.38861 163.34 30.4966 177.208C54.6046 191.076 70.6406 171.284 104.213 170.736C137.785 170.188 146.881 175.184 174.509 156.24C202.137 137.296 206.613 91.7917 184.209 57.7957C161.805 23.7997 134.385 14.9757 134.385 14.9757Z"
        fill="#85C553"
      />
      <path
        opacity="0.7"
        d="M134.385 14.9757C134.385 14.9757 102.289 3.0197 71.1526 21.0197C40.0166 39.0197 24.6486 75.3317 11.4206 104.408C-1.80739 133.484 6.38861 163.34 30.4966 177.208C54.6046 191.076 70.6406 171.284 104.213 170.736C137.785 170.188 146.881 175.184 174.509 156.24C202.137 137.296 206.613 91.7917 184.209 57.7957C161.805 23.7997 134.385 14.9757 134.385 14.9757Z"
        fill="white"
      />
      <path
        d="M69.0445 95.2119L53.5005 103.664"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.5925 49.124L56.2285 55.668"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.5005 12.0361L70.1365 29.2161"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.7686 4.3999L95.2246 18.0359"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.856 36.8523L140.764 22.9443"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M146.216 64.9396L158.216 60.8516"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M134.764 95.4844L144.852 101.208"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.9565 36.5801L64.1365 42.8521"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M144.037 48.3076L135.309 52.3956"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.9524 78.0322L49.6804 80.7562"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M138.581 81.5762L142.945 82.6682"
        stroke="black"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M142.317 65.3401C140.773 64.2721 134.965 65.2201 131.289 68.1841C127.613 71.1481 126.785 72.2161 126.785 72.2161C126.785 72.2161 125.125 60.5961 125.125 60.2401C125.125 59.8841 122.753 38.0681 122.277 34.8681C121.801 31.6681 121.077 26.9241 120.381 25.8561C119.685 24.7881 116.825 24.6561 115.877 25.1481L114.929 25.6201C114.929 25.6201 115.401 17.3201 114.453 15.3041C113.505 13.2881 110.541 14.4761 109.709 15.5441C109.117 16.3855 108.64 17.3015 108.289 18.2681C108.289 18.2681 105.561 17.3201 104.021 20.4041C102.481 23.4881 101.293 26.2121 101.057 29.1761C100.821 32.1401 99.5126 35.9361 99.5126 35.9361C99.5126 35.9361 97.9726 33.4441 96.3126 34.8681C94.6526 36.2921 92.7566 41.8641 92.2806 45.8961C91.8046 49.9281 91.3326 60.5961 91.3326 60.5961C91.3326 60.5961 90.3846 65.4561 89.9086 69.3721C89.4326 73.2881 89.7926 89.5281 91.5686 96.2841C93.3446 103.04 95.7206 107.312 95.7206 107.312C95.7206 107.312 99.8686 120.944 100.461 122.844C101.053 124.744 107.577 150.588 107.577 150.588L127.021 125.908C127.021 125.908 122.161 112.512 121.093 109.428C120.025 106.344 119.313 105.396 119.313 105.396C119.313 105.396 125.241 96.9961 128.445 94.4881C131.649 91.9801 133.305 83.6881 134.133 80.0241C134.961 76.3601 138.401 71.2521 140.301 69.5921C142.201 67.9321 143.857 66.4081 142.317 65.3401ZM98.4446 59.6481C98.0926 59.6481 98.2086 55.0241 98.2086 49.4521C98.2086 43.8801 99.1566 41.3881 99.1566 41.3881C98.6846 43.8801 99.6326 56.2081 99.6326 57.0401C99.6326 57.8721 98.8006 59.6481 98.4446 59.6481Z"
        fill="white"
        stroke="black"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.376 107.44C117.86 106.688 118.128 105.888 118.128 105.888"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M104.729 104.708C104.729 104.708 111.253 108.976 114.453 108.144"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.785 72.2158C126.785 72.2158 124.293 76.1278 123.701 77.5518C123.109 78.9758 122.753 80.1598 121.701 80.7518C120.649 81.3438 119.213 82.1758 119.213 82.1758"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M119.62 73.376C116.604 74.776 112.36 77.248 109.948 80.872"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.108 71.9805C123.108 71.9805 122.237 72.2485 120.917 72.7805"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M108.645 82.4121C108.645 82.4121 106.509 86.3241 105.561 89.4081"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M108.289 18.2686C108.289 18.2686 107.693 23.2486 106.865 30.7086C106.037 38.1686 105.561 41.8526 105.665 46.5966C105.769 51.3406 107.101 55.5086 106.989 56.0926"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M114.929 25.6201C114.711 27.9871 114.711 30.3691 114.929 32.7361C115.281 36.7641 114.573 44.2361 114.573 47.0801C114.573 49.9241 114.689 54.1961 114.809 55.4801C114.893 56.288 115.178 57.062 115.637 57.7321"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M117.181 58.4639C117.181 58.4639 117.773 59.5279 121.685 59.6639"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M108.188 55.6162C108.188 55.6162 111.032 56.2082 112.932 55.8562"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M97.8525 60.5957C97.8525 60.5957 97.8525 61.7957 94.4165 62.8477"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M104.613 57.3964C104.969 57.1604 106.389 56.6844 106.745 55.0244"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M104.817 75.5561C104.817 75.5561 112.189 72.8561 116.857 71.8721"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M125.745 195.564H189.481C185.029 189.688 168.785 168.276 167.725 167.216C166.497 165.988 161.089 165.252 161.089 165.252L145.117 151.98L125.213 119.052L106.289 145.348L103.089 132.548L95.9685 159.108C95.9685 159.108 121.773 190.564 122.769 191.792C122.945 192.028 124.057 193.44 125.745 195.564Z"
        fill="black"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.8367 103.38C75.8367 103.38 70.5607 89.8681 69.2887 87.3801C68.0167 84.8921 61.1127 74.0881 60.7647 71.1601C60.4167 68.2321 59.3367 63.3521 58.2247 61.3121C57.1127 59.2721 60.4247 57.9361 63.1607 60.5121C65.8967 63.0881 67.5607 67.3121 67.5207 68.5121C67.4807 69.7121 73.6647 74.2521 73.6647 74.2521L74.7887 63.8521C74.7887 63.8521 75.9887 38.0161 75.7367 34.1601C75.4847 30.3041 75.2367 22.1161 78.2967 21.8001C81.3567 21.4841 81.8287 23.9081 81.8287 23.9081C81.8287 23.9081 81.9407 17.8041 85.3407 18.2001C87.9407 18.5001 88.9407 20.9521 89.3167 22.1281C89.6927 23.3041 90.1447 24.7761 90.1447 24.7761C90.1447 24.7761 92.2887 23.3201 94.3807 26.7761C95.5807 28.7761 98.1327 35.0321 98.5447 36.6241C98.9567 38.2161 99.0847 38.7921 99.0847 38.7921C99.9877 38.8154 100.863 39.1065 101.601 39.6286C102.338 40.1506 102.903 40.88 103.225 41.7241C104.497 44.7521 106.305 52.6561 108.053 59.1881C109.123 63.3531 109.685 67.6321 109.729 71.9321C109.729 71.9321 110.413 92.9601 109.005 99.6481C107.597 106.336 104.949 112.048 104.405 112.58C103.861 113.112 96.0407 136.212 96.0407 136.212L68.9047 126.152C68.9047 126.152 74.5567 112.268 75.4487 109.24C75.9855 107.335 76.1177 105.339 75.8367 103.38Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.1567 83.668C70.1753 84.3869 70.291 85.1 70.5007 85.788"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.8328 75.4043C71.7142 76.877 70.9207 78.5703 70.5048 80.3723C70.357 80.9624 70.2541 81.5627 70.1968 82.1683"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M81.8288 23.9082C81.8288 23.9082 82.3008 32.3082 82.6288 36.4282C82.9568 40.5482 83.0968 46.9722 83.1248 51.1802C83.1528 55.3882 82.6408 60.6722 82.3528 61.8202C82.1026 62.7095 81.7926 63.5808 81.4248 64.4282"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.1448 24.7686C89.7495 25.2641 89.4649 25.8386 89.3104 26.4534C89.1558 27.0682 89.1348 27.709 89.2488 28.3326C89.6928 30.3326 91.7568 41.5566 91.7528 43.1806C91.7488 44.8046 91.8688 58.9206 91.9008 59.8766C91.9328 60.8326 91.2568 64.0486 90.9368 65.3246"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.0848 38.792C99.0848 38.792 97.5568 38.948 97.8848 41.34C98.2128 43.732 98.9888 51.504 98.9888 53.668C98.9888 55.832 99.4928 60.836 99.3888 65.552C99.2848 70.268 100.393 71.908 100.905 73.108"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.4847 70.248C75.4847 70.248 74.9407 72.956 75.6727 74.356C76.4047 75.756 77.4207 78.724 77.4167 80.356"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.9646 68.9121C80.9646 68.9121 80.6766 71.1441 80.9926 72.5761C81.2698 73.6061 81.71 74.5852 82.2966 75.4761"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.1046 72.4238C90.1046 72.4238 89.7846 74.7838 90.3566 76.2798C90.7008 77.183 91.1154 78.0577 91.5966 78.8958"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.7887 195.564L103.017 138.64C103.017 138.64 92.2607 129.752 85.1807 125.108C78.1007 120.464 69.6127 120.584 69.6127 120.584C69.6127 120.584 58.5287 144.204 57.9447 145.708C57.3607 147.212 49.6327 163.216 49.6327 163.216C49.6327 163.216 46.2367 164.416 44.7287 167.14C43.5487 169.268 35.0367 187.708 31.4087 195.584L77.7887 195.564Z"
        fill="#85C553"
        stroke="black"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.6507 142.371C96.7688 141.71 97.1391 140.268 96.4779 139.149C95.8167 138.031 94.3742 137.661 93.2562 138.322C92.1381 138.983 91.7677 140.426 92.4289 141.544C93.0902 142.662 94.5326 143.032 95.6507 142.371Z"
        fill="black"
        stroke="black"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.1808 149.716C93.0678 150.167 92.8235 150.575 92.4787 150.888C92.134 151.2 91.7043 151.403 91.244 151.472C90.7838 151.54 90.3136 151.47 89.893 151.271C89.4725 151.072 89.1204 150.753 88.8813 150.353C88.6422 149.954 88.5269 149.493 88.55 149.028C88.5731 148.564 88.7335 148.116 89.0109 147.743C89.2883 147.369 89.6703 147.086 90.1085 146.93C90.5467 146.773 91.0215 146.751 91.4728 146.864C91.7723 146.939 92.0542 147.072 92.3023 147.256C92.5504 147.44 92.7597 147.671 92.9184 147.936C93.077 148.201 93.1819 148.494 93.2269 148.8C93.2719 149.105 93.2562 149.417 93.1808 149.716Z"
        fill="black"
        stroke="black"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ApproveCandidateIcon;
